import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import SearchInput from "src/components/widgets/SearchInput";
import CustomDataTable from "src/components/CustomDataTable";
import { useQuery } from "@tanstack/react-query";
import BackIcon from "../images/back.png";
import { getArchivedCustomers } from "src/api/customer";
import { getCustomizationValue } from "src/lib/utils";
import { useAuth } from "src/providers/AuthProvider";

const columns = [
	{ name: "Cust ID", selector: (row) => row.customer_id, width: "120px" },
	{ name: "First Name", selector: (row) => row.first_name },
	{ name: "Last Name", selector: (row) => row.last_name },
	{ name: "Email", selector: (row) => row.email, grow: 1.5 },
	{ name: "Phone", selector: (row) => row.phone, grow: 0.75 },
	{
		name: "Actions",
		cell: (row) => <Link to={`/customers/${row.uuid}`}>View</Link>,
		width: "120px",
	},
];

const ArchivedCustomers = () => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const search = searchParams.get("search");
	const page = searchParams.get("page") || 1;
	const limit = searchParams.get("limit") || 10;

	const { data, isLoading } = useQuery({
		queryKey: ["customers", "archived", page, limit, search],
		queryFn: () => getArchivedCustomers({ page, limit, search }),
	});

	const customers = data?.data?.data ?? [];
	const totalRow = data?.data?.total;

	return (
		<>
			<div className="pageTop">
				<button className="transparent-btn" onClick={() => navigate("..", { relative: "path" })}>
					<img src={BackIcon} alt="back-button" />
				</button>
				<h2>Archived {getCustomizationValue(user, "customer_label")}</h2>
			</div>
			<div className="innerContent">
				<ActionBar />

				<CustomDataTable columns={columns} data={customers} progressPending={isLoading} paginationTotalRows={totalRow} />
			</div>
		</>
	);
};

const ActionBar = () => {
	return (
		<div className="inner-top !tw-justify-end tw-flex-wrap tw-gap-3">
			<SearchInput name="search" placeholder="Search..." />
		</div>
	);
};

export default ArchivedCustomers;
